export default __webpack_public_path__ + "static/media/success-transparent.1014ab63.svg";